import { render } from "./LinkPreview.vue?vue&type=template&id=166fe1e0&scoped=true"
import script from "./LinkPreview.vue?vue&type=script&lang=js"
export * from "./LinkPreview.vue?vue&type=script&lang=js"

import "./LinkPreview.vue?vue&type=style&index=0&id=166fe1e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166fe1e0"]])

export default __exports__